import { Heading, Text, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { RPSContext } from '../../context/RPSContext'
import { shortAddress } from '../../utils/minorUtils'

const GameResult = () => {
  const { gameDetails } = useContext(RPSContext)

  return (
    <VStack spacing={'15px'} textAlign={'center'} minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      {gameDetails.state === 2 && gameDetails.winner === gameDetails.player && (
        <>
          <Heading fontSize={'2xl'}>Congratulations! &nbsp; 🎉🎉🎉</Heading>
          <Heading color={'second.500'}>You have won this Game!!!</Heading>
          <Text fontSize={'2xl'}>
            Opponent:{' '}
            {gameDetails.winner === gameDetails.initiator
              ? shortAddress(gameDetails.responder)
              : shortAddress(gameDetails.initiator)}
          </Text>
          <Text fontSize={'xl'} color={'brand.500'}>
            {gameDetails.comment}
          </Text>
        </>
      )}
      {gameDetails.state === 2 && gameDetails.winner !== gameDetails.player && (
        <>
          <Heading fontSize={'2xl'}>Oh No! 😥🥲😭</Heading>
          <Heading color={'second.500'} textAlign={'center'}>
            You have lost this Game!!!
          </Heading>
          <Text fontSize={'2xl'}>Opponent: {shortAddress(gameDetails.winner)}</Text>
          <Text fontSize={'xl'} color={'brand.500'}>
            {gameDetails.comment}
          </Text>
        </>
      )}
      {gameDetails.state === 3 && (
        <>
          <Heading fontSize={'2xl'}>Its a DRAWWWWWWW 😑😑😑</Heading>
          <Text color={'second.500'}>No Winners and No Losers!!!</Text>
          <Text fontSize={'2xl'}>
            Opponent:
            {gameDetails.player === gameDetails.initiator
              ? shortAddress(gameDetails.responder)
              : shortAddress(gameDetails.initiator)}
          </Text>
          <Text fontSize={'xl'} color={'brand.500'}>
            {gameDetails.comment}
          </Text>
        </>
      )}
    </VStack>
  )
}
export default GameResult
